export const subCategoryList = [
    'Rs 5',
    'Rs 10',
    'Rs 20',
    'Rs 30',
    'Rs 50',
    'Large Packing',
    'Nimko',
    'Sweet',
    'Revri',
    'Chips',
    'China Items',
    'Others'
];

export const productCategories = [
    'KK',
    'TITO',
    'LOOSE',
    // 'KK Ctn',
    // 'KK Loose',
    // 'KK POPS',
    // 'KK POPS Bora',
    // 'TITO COTTON',
    // 'TITO Bundle',
    // 'TITO Snacks',
    // 'TITO Bora',
    // 'LOOSE',
    'Legacy Foods',
    'Malai Boti',
    'General Catageory'
];

export const productSubCategories = {
    'KK Ctn': ['Rs 5', 'Rs 10', 'Rs 20', 'Rs 30', 'Rs 50', 'Large Packing', 'Others'],
    'KK Loose': ['Rs 5', 'Rs 10', 'Rs 20', 'Large Packing', 'Others'],
    'KK POPS': ['Rs 10', 'Rs 20', 'Rs 30', 'Large Packing', 'Others'],
    'KK POPS Bora': ['Rs 10', 'Rs 20', 'Large Packing', 'Others'],
    'TITO COTTON': ['Rs 5', 'Rs 10', 'Rs 20'],
    'TITO Bundle': ['Rs 5', 'Rs 10', 'Rs 20', 'Others'],
    'TITO Snacks': ['Rs 10', 'Rs 20', 'Others'],
    'TITO Bora': ['Rs 5', 'Rs 10', 'Rs 20'],
    'LOOSE': ['Nimko', 'Sweet', 'Others', 'Revri', 'Chips', 'China Items'],
    'Legacy Foods': ['Rs 5', 'Rs 10', 'Rs 20', 'Rs 30', 'Rs 50', 'Large Packing', 'Others'],
    'Malai Boti': ['Rs 5', 'Rs 10', 'Rs 20', 'Rs 30', 'Rs 50', 'Large Packing', 'Others']
};
